/*
 * NOTICE:  All information contained herein is, and remains the property of Power Settlements Consulting and Software, LLC. 
 * The intellectual and technical concepts contained herein are proprietary to Power Settlements Consulting and Software, LLC 
 * and are protected by trade secret or copyright law. Dissemination or reproduction of this material, in whole or in part, 
 * is strictly forbidden without the prior written permission of Power Settlements Consulting and Software, LLC.
 * Copyright (c) Power Settlements Consulting and Software, LLC. All rights reserved.
*/

import moment from 'moment';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { TOOLS_API } from '@/api';

const state = {
  tableData: [],
  
};

const actions = {
  async fetchResourceCount({ commit }, parameters) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeListSelected);
    const params = {
      startDate,
      endDate,
    };
    try {
      const { data: { data } } = await TOOLS_API.get('application/system-information/resource-count', { params });
      commit('setTableData', data);
    } catch {
      this.$notify('Failed to resource counts', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};